import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { useNavigate } from 'react-router-dom';
import { ERROR } from '../../../core-utils/routes';

export interface LoaderProps {
  width?: string;
  height?: string;
}

const loaderKeyframes = keyframes`
  0% {
    height: 10px;
    width: 10px;
    margin-bottom: 6px;
  }
  50% {
    height: 20px;
    width: 20px;
    margin-bottom: 12px;
  }
  100% {
    height: 10px;
    width: 10px;
    margin-bottom: 6px;
  }
`;

const LoaderComponent = styled.div`
  .container {
    height: 40px;
    display: flex;
    align-items: flex-end;
  }
  .dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    margin-right: 11px;
    animation: ${loaderKeyframes} 1.5s infinite;
  }
  .dot:nth-child(1) {
    animation-delay: 0s;
    background-color: #e44001;
  }
  .dot:nth-child(2) {
    animation-delay: 0.2s;
    background-color: #f37201;
  }
  .dot:nth-child(3) {
    animation-delay: 0.4s;
    background-color: #ffca1a;
  }
  .dot:nth-child(4) {
    animation-delay: 0.6s;
    background-color: #ffd573;
  }
`;

const Loader: React.FC<LoaderProps> = ({ width, height }) => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: width ?? '100%',
      height: height ?? 'calc(100vh - 60px)',
    },
    text: {
      textAlign: 'center',
    },
  });

  const getUrlParameter = (name: string) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  };

  const navigate = useNavigate();

  useEffect(() => {
    const error = getUrlParameter('error');
    if (error) {
      const errorDescription =
        getUrlParameter('error_description') +
        ' Please clear cache, cookies and login again.';
      navigate(ERROR, { state: { errorDescription } });
    }
  }, [navigate]);

  const getTypographyForLoader = (texts: string[]) => {
    return (
      <Typography
        fontSize="14px"
        fontType="medium"
        lineHeight="25px"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
        margin="28px 0px 0px 0px"
      >
        <Typography
          fontSize="14px"
          fontType="medium"
          lineHeight="25px"
          textColor={patientAccessTheme.palette.text.highemphasis}
          component="span"
        >
          {texts[0]}
        </Typography>
        {texts[1]}
      </Typography>
    );
  };

  const { classes } = useStyles();

  return (
    <Grid container className={classes.root}>
      <LoaderComponent>
        <div className="container">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </LoaderComponent>
      <Grid className={classes.text}>
        {getTypographyForLoader(
          componentConstants.MOLECULES.LOADER.LOADING_LABEL_LIST[
            new Date().getSeconds() % 25
          ],
        )}
      </Grid>
    </Grid>
  );
};

export default Loader;
